import {Module} from 'vuex-class-modules';
import store from '@/store';
import {questionCollectionApi as api} from '@/api';
import {
  QuestionCollectionAttributes as Attributes,
  QuestionCollectionCreate as Create,
  QuestionCollectionResource as Resource,
} from '@/interfaces';
import {ResourceType} from '@/enums';
import {CrudModuleAbstract} from './CrudModuleAbstract';
import {parseISO} from 'date-fns';

const defaultItem = (): Resource => {
  return {
    id: 'new',
    type: ResourceType.QuestionCollection,
    attributes: {
      id: 0,
      key: '',
      label: '',
      repeatable: false,
      userCreated: {id: 0, firstName: '', lastName: ''},
      userModified: {id: 0, firstName: '', lastName: ''},
      userIdCreated: 0,
      userIdModified: 0,
      created: new Date(),
      modified: new Date(),
    },
  };
};

@Module
class QuestionCollectionModule extends CrudModuleAbstract<
  Resource,
  Attributes,
  Create
> {
  public cast(item: Resource): Resource {
    item.attributes.repeatable = Boolean(item.attributes.repeatable);
    item.attributes.created = parseISO(String(item.attributes.created));
    item.attributes.modified = parseISO(String(item.attributes.modified));
    return item;
  }
}

export const questionCollectionModule = new QuestionCollectionModule(
  {
    store,
    name: ResourceType.QuestionCollection,
  },
  () => api,
  defaultItem
);
